export default __webpack_public_path__ + "static/media/greenline_icon.a4881edc.svg";